import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IPaginatedResponse, IProductForOrder } from "../types/seederOrders";

const API = process.env.REACT_APP_API;

interface UseProductsForOrderParams {
  category?: string;
  farmer?: number;
  search?: string;
}

const useProductsForOrder = (params?: UseProductsForOrderParams) => {
  const fetch = useFetch();
  const searchTerm = params?.search?.trim();

  const queryParams = new URLSearchParams();
  if (params?.category) {
    queryParams.append("category", params.category);
  }
  if (params?.farmer) {
    queryParams.append("farmer", params.farmer.toString());
  }
  if (searchTerm) {
    queryParams.append("search", searchTerm);
  }

  const queryString = queryParams.toString();
  const url = `${API}/api/semeadora/products/${queryString ? `?${queryString}` : ""}`;

  return useQuery({
    queryKey: ["products-for-order", { ...(params || {}), search: searchTerm }],
    queryFn: () => {
      return fetch(url, {
        method: "GET",
      }) as Promise<IPaginatedResponse<IProductForOrder>>;
    },
  });
};

export default useProductsForOrder;
